import React, { useCallback, useEffect, useState } from 'react';
import { Button, IconButton, Tooltip, Typography } from '@material-ui/core';
import Alert from "@material-ui/lab/Alert";
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from "react-i18next";
import useStyles from './Read.style';
import YesNoDialog from '../../../components/YesNoDialog';
import Cookies from 'universal-cookie';
import CustomNoRowsOverlay from '../../../components/CustomNoRowsOverlay';
import UserDataGrid from '../../../components/UserDataGrid';


const cookies = new Cookies();

const Read = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deletionMessageId, setDeletionMessageId] = useState('');
  const [deleteResult, setDeleteResult] = useState({});

  const columns = [
    { field: 'title', headerName: t('common.table.header.title'), width: 230 },
    { field: 'author', headerName: t('common.table.header.author'), width: 230 },
    {
      field: 'createdAt',
      headerName: t('common.table.header.createdAt'),
      width: 150,
      valueFormatter: params => new Date(params.value).toLocaleDateString()
    },
    {
      field: 'id',
      headerName: ' ',
      width: 120,
      renderCell: (params) => (
        <>
          <Tooltip arrow title={t('common.table.action.edit')}>
            <IconButton
              aria-label={t('common.table.action.edit')}
              color="primary"
              component={Link}
              to={`/provider/message/${params.value}`}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip arrow title={t('common.table.action.delete')}>
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={() => {
                setOpenDeleteDialog(true);
                setDeletionMessageId(params.value);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const getMessages = useCallback(
    async () => {
      try {
        let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}`, {
          headers: {
            'X-ACCESS-TOKEN': cookies.get('token')
          }
        });
        let json = await response.json();
        if (!response.ok) {
          setError(json.message);
          return;
        };
        setMessages(json.map((message, index) => {
          return {
            id: message._id,
            title: message.title,
            author: message.author,
            createdAt: message.createdAt
          }
        }));
      } catch (error) {
        console.log(error);
        setError(`${t('module.provider.listMessage.message.fetchDataFailure')}.${t('common.message.error.seeLog')}.`);
      } finally {
        setLoading(false);
      }
    }, [t]);

  useEffect(() => {
    getMessages();
    if (deleteResult.severity === 'success') {
      setTimeout(() => setDeleteResult({}), 2000);
    }
  }, [getMessages, deleteResult]);

  const handleDeleteDialogAnswer = answer => async e => {
    setOpenDeleteDialog(false);
    if (answer !== 'yes') return;

    try {
      let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}/${deletionMessageId}`, {
        method: 'delete',
        headers: {
          'X-ACCESS-TOKEN': cookies.get('token')
        }
      });
      if (!response.ok) {
        let json = await response.json();
        setDeleteResult({
          severity: 'error',
          message: json.message
        });
      };
      setDeleteResult({
        severity: 'success',
        message: t('module.provider.listMessage.message.deleteMessageSuccess')
      });
      getMessages();
    } catch (error) {
      console.log(error);
      setDeleteResult({
        severity: 'error',
        message: `${t('module.provider.listMessage.message.deleteMessageFailure')}.${t('common.message.error.seeLog')}`
      });
    };
  };

  if (error) return <Alert severity="error">{error}</Alert>

  return (
    <>
      <Typography variant="h4" className={classes.title}>{t('module.provider.listMessage.title')}</Typography>
      {deleteResult.severity &&
        <Alert severity={deleteResult.severity}>{deleteResult.message}</Alert>
      }
      <Button
        variant="contained"
        color="primary"
        className={classes.addButton}
        component={Link}
        to="/provider/message/add"
        startIcon={<AddIcon />}
      >
        {t('common.form.button.addNew')}
      </Button>
      <UserDataGrid
        rows={messages}
        columns={columns}
        loading={loading}
        components={{
          noRowsOverlay: CustomNoRowsOverlay,
        }}
      />
      <YesNoDialog
        title="Are you sure?"
        text="This will remove the message"
        open={openDeleteDialog}
        onAnswer={handleDeleteDialogAnswer}
      />
    </>
  );
};
export default Read;